import React from 'react';
import {useSelector} from "react-redux";
import {airtable_config_get_label, airtable_config_get_link} from "../redux/actions";
import {airtable_text_format} from '../airtable-text-format';

export const IvalidEmail = () => {
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const userEmail = useSelector(state => state.app.userEmail)
    const title = configData !== null ? airtable_config_get_label(configData, 'invalid_email_title', locale) : null;
    let text = configData !== null ? airtable_config_get_label(configData, 'invalid_email_text', locale) : null;
    let btn = configData !== null ? airtable_config_get_label(configData, 'invalid_email_btn', locale) : null;
    let btn_link = configData !== null ? airtable_config_get_link(configData, 'invalid_email_btn', locale) : null;
    if (text !== null) {
        text = text.replace('$$email$$',userEmail);
        text = airtable_text_format(text);
    }

    return (
        <div className="invalid-email container">
            <div className="container__wrap">
                <h1 className="invalid-email__title">{title}</h1>
                <div className="invalid-email__box">
                    <div className="invalid-email__text" dangerouslySetInnerHTML={{__html: text}}/>
                    <div className="invalid-email__btns">
                        <a href={btn_link} className="invalid-email__btn">{btn}</a>
                    </div>


                </div>
            </div>
        </div>)
}